export const BULK_UPDATE_REQUEST = 'BULK_UPDATE_REQUEST';
export const bulkUpdateRequest = (bulkUpdateJobId) => ({
  type: BULK_UPDATE_REQUEST,
  bulkUpdateJobId,
});

export const BULK_UPDATE_REQUEST_SUCCESS = 'BULK_UPDATE_REQUEST_SUCCESS';
export const bulkUpdateRequestSuccess = (bulkUpdateJobId) => ({
  type: BULK_UPDATE_REQUEST_SUCCESS,
  bulkUpdateJobId,
});

export const BULK_UPDATE_CHANGE_MODEL = 'BULK_UPDATE_CHANGE_MODEL';
export const changeModel = (bulkUpdateJobId, modelUpdate) => ({
  type: BULK_UPDATE_CHANGE_MODEL,
  bulkUpdateJobId,
  modelUpdate,
});

export const BULK_UPDATE_SET_MODEL = 'BULK_UPDATE_SET_MODEL';
export const setModel = (bulkUpdateJobId, model) => ({
  type: BULK_UPDATE_SET_MODEL,
  bulkUpdateJobId,
  model,
});

export const START_BULK_UPDATE_JOB = 'START_BULK_UPDATE_JOB';
// data type could also be fulfillmentPlan
export const startBulkUpdateJob = (bulkUpdateTypeData, bulkActions, fulfillmentPlanIds, bulkUpdateJobId, filters, source) => ({
  type: START_BULK_UPDATE_JOB,
  bulkUpdateTypeData,
  bulkActions,
  ids: fulfillmentPlanIds,
  id: bulkUpdateJobId,
  filters,
  source,
});

export const START_BULK_UPDATE_JOB_FROM_DRAWER = 'START_BULK_UPDATE_JOB_FROM_DRAWER';
export const startBulkUpdateJobFromDrawer = (bulkUpdateTypeData, bulkActions, fulfillmentPlanIds, bulkUpdateJobId, filters) => ({
  type: START_BULK_UPDATE_JOB_FROM_DRAWER,
  bulkUpdateTypeData,
  bulkActions,
  ids: fulfillmentPlanIds,
  id: bulkUpdateJobId,
  filters,
});

export const START_BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB = 'START_BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB';
// data type could also be fulfillmentPlan
export const startBulkUpdateDoNotNotifyMarketPlaceJob = (
  bulkUpdateTypeData,
  bulkActions,
  fulfillmentPlanIds,
  bulkUpdateJobId,
  filters,
) => ({
  type: START_BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB,
  bulkUpdateTypeData,
  bulkActions,
  ids: fulfillmentPlanIds,
  id: bulkUpdateJobId,
  filters,
});

export const BULK_UPDATE_GET_JOB_DATA_SUCCESS = 'BULK_UPDATE_GET_JOB_DATA_SUCCESS';
export const requestJobDataSuccess = (bulkUpdateJobId, bulkUpdateJobData) => ({
  type: BULK_UPDATE_GET_JOB_DATA_SUCCESS,
  bulkUpdateJobId,
  bulkUpdateJobData,
});

export const VALIDATE_BULK_UPDATE_JOB = 'VALIDATE_BULK_UPDATE_JOB';
// data type could also be fulfillmentPlan
export const validateBulkUpdateJob = (bulkUpdateJobId) => ({
  type: VALIDATE_BULK_UPDATE_JOB,
  bulkUpdateJobId,
});

export const VALIDATE_BULK_UPDATE_JOB_SUCCESS = 'VALIDATE_BULK_UPDATE_JOB_SUCCESS';
export const validateBulkUpdateJobSuccess = (bulkUpdateJobId, validationErrors) => ({
  type: VALIDATE_BULK_UPDATE_JOB_SUCCESS,
  bulkUpdateJobId,
  validationErrors,
});

export const UPDATE_BULK_UPDATE_JOB = 'UPDATE_BULK_UPDATE_JOB';
export const updateBulkUpdateJob = (bulkUpdateJobId, propertiesToUpdate) => ({
  type: UPDATE_BULK_UPDATE_JOB,
  bulkUpdateJobId,
  propertiesToUpdate,
});

// reducer only
export const DELETE_BULK_UPDATE_JOB = 'DELETE_BULK_UPDATE_JOB';
export const deleteBulkUpdateJob = (bulkUpdateJobId) => ({
  type: DELETE_BULK_UPDATE_JOB,
  bulkUpdateJobId,
});

export const BULK_UPDATE_JOB_COMPLETE = 'BULK_UPDATE_JOB_COMPLETE';
export const bulkUpdateJobComplete = (pusherJobGuid) => ({
  type: BULK_UPDATE_JOB_COMPLETE,
  pusherJobGuid,
});

export const BULK_UPDATE_VALIDATE_JOB_FOR_DRAWER = 'BULK_UPDATE_VALIDATE_JOB_FOR_DRAWER';
export const validateJobForDrawer = (bulkUpdateJobId) => ({
  type: BULK_UPDATE_VALIDATE_JOB_FOR_DRAWER,
  bulkUpdateJobId,
});

export const BULK_UPDATE_READ_SCALE_REQUEST = 'BULK_UPDATE_READ_SCALE_REQUEST';
export const bulkUpdateReadFromScale = (scale, requestId) => ({
  type: BULK_UPDATE_READ_SCALE_REQUEST,
  scale,
  requestId,
});

export const SET_CARRIER_AND_CONFIRMATION_TYPES = 'SET_CARRIER_AND_CONFIRMATION_TYPES';
export const setCarrierAndConfirmationTypes = (bulkUpdateJobId, carrierId, confirmationTypes, isNewCarrierSelected) => ({
  type: SET_CARRIER_AND_CONFIRMATION_TYPES,
  bulkUpdateJobId,
  carrierId,
  confirmationTypes,
  isNewCarrierSelected,
});

export const INITIALIZE_ZERO_WEIGHT_BULK_UPDATE = 'INITIALIZE_ZERO_WEIGHT_BULK_UPDATE';
export const initializeZeroWeightBulkUpdate = (sellerDefaultWeightUnit) => ({
  type: INITIALIZE_ZERO_WEIGHT_BULK_UPDATE,
  sellerDefaultWeightUnit,
});
